module.exports = __webpack_public_path__ + "static/media/heroimg.90c90aa3.png";